"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overridings = exports.default = void 0;

var _styles = require("@mui/material/styles");

var white = '#FFFFFF';
var black = '#000000';
var overridings = {
  name: 'SACD Default Theme',
  palette: {
    primary: {
      main: '#dc291b',
      dark: '#b6180c'
    },
    secondary: {
      main: '#0c2043'
    },
    error: {
      main: '#dc291b',
      primary: '#ffe8e8',
      secondary: 'rgba(250,65,65,0.12)',
      tertiary: '#ff2946'
    },
    // warning actually not defined in Zeplin's charte.. so, default mui colors.
    // warning: {
    //   main: '#dcecff',
    //   light: '#dcecff',
    //   dark: '#dcecff',
    // },
    info: {
      main: '#dcecff',
      light: '#dcecff',
      dark: '#dcecff'
    },
    success: {
      main: '#0c2043',
      light: '#0c2043',
      dark: '#0c2043'
    },
    color: {
      grey: '#9d9d9d',
      darkGrey: '#656a72',
      darkIndigo: 'rgba(12, 32, 67, 0.3)',
      lightGrey: '#bcbcbc',
      veryLightGrey: '#e2e2e2',
      veryLightGrey2: '#f2f2f2',
      paleGrey: '#f5f6fa',
      green: '#7ec438',
      corail: '#ff7f51',
      blueLight: '#dcecff',
      blueDark: '#07152c',
      white: white,
      black: black,
      paleDark: '#232323',
      lightBlack: 'rgba(255, 255, 255, 0.3)'
    },
    background: {
      default: '#f5f6fa'
    }
  }
};
exports.overridings = overridings;

var _default = (0, _styles.createTheme)(overridings);

exports.default = _default;